<template>
  <a-modal
    :visible="ShowPanel"  :mask="false" width="50%"
    title="新增配置数据"
    @ok="handleOk()"
    @cancel="handleCancel()">
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="addLoading" @click="handleOk">
        提交
      </a-button>
    </template>
    <a-form >
      <a-form-item label="渠道" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-select v-model="channel"
                  show-search @change="changeChannel"
                  optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option value="facebook" label="Facebook">Facebook</a-select-option>
          <a-select-option value="tiktok" label="TikTok">TikTok</a-select-option>
          <a-select-option value="twitter" label="Twitter">Twitter</a-select-option>
          <a-select-option value="Kakao" label="Kakao">Kakao</a-select-option>
          <a-select-option value="bytedance" label="巨量广告">巨量广告</a-select-option>
          <a-select-option value="tencent" label="腾讯广告">腾讯广告</a-select-option>
          <a-select-option value="vk_ads" label="VK Ads">VK Ads</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="代理商" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-select v-model="account"
                  show-search allowClear @change="changeChannel"
                  optionFilterProp="label" placeholder="请选择代理商">
          <a-select-option :value="accountIndex" :label="accountItem" :key="accountIndex"
                           v-for="(accountItem,accountIndex) in accountList">
            {{accountItem}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="账户" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-select v-model="advertiser"
                  show-search allowClear
                  mode="multiple" :maxTagCount="1"
                  optionFilterProp="label" placeholder="请选择账户">
          <a-select-option :value="advertiserItem.advertiser_id"
                           :key="advertiserItem.advertiser_id"
                           :label="advertiserItem.name+advertiserItem.advertiser_id"
                           v-for="advertiserItem in advertiserList">
            {{advertiserItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="国家" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-select v-model="country" allowClear
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择国家">
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{countryItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="日期" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD" />
      </a-form-item>
      <a-form-item label="类别" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-radio-group button-style="solid" v-model="cate">
           <a-radio-button value="">
             全部
           </a-radio-button>
           <a-radio-button value="game">
             游戏
           </a-radio-button>
           <a-radio-button value="ai">
             AI
           </a-radio-button>
         </a-radio-group>
      </a-form-item>
      <a-form-item label="返点比例" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-input-number v-model="ratio" ></a-input-number>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {ConfigSpendRebate, GetAccountAdvertiser} from "../../../api/v1/spend_rebate_api";

export default {
  name: "ConfigPanel",
  props: ["ShowPanel"],
  data(){
    return {
      channel:'',
      account:'',
      advertiser:[],
      country:[],
      date:[],
      ratio:8,
      cate: '',
      accountList:{},
      advertiserList:[],
      addLoading:false
    }
  },
  mounted() {
  },
  methods:{
    changeChannel(){
      GetAccountAdvertiser({
        channel:this.channel,
        account:this.account
      }).then(resp => {
        if (resp.code == 200){
          this.advertiser = []
          this.accountList = resp.data.account_list
          this.advertiserList = resp.data.advertiser_list
        }
      })
    },
    handleOk(){
      this.addLoading = true
      ConfigSpendRebate({
        channel:this.channel,
        account:this.account,
        advertiser:this.advertiser,
        country:this.country,
        date:this.date,
        ratio:this.ratio,
        cate:this.cate
      }).then(resp => {
        this.addLoading = false
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.handleCancel()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.channel=''
      this.account=''
      this.advertiser=[]
      this.country=[]
      this.date=[]
      this.ratio=8
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Rebate/ConfigPanel.vue